import { createSelector } from '@reduxjs/toolkit';
import { getProfileState } from './getProfileState';

export const getHasPrimaryCity = createSelector(getProfileState, (state) => state?.hasPrimaryCity);
